interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 32, className }: LogoProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-label="Tijera" className={className}>
      <path d="M6 6 L26 26" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M26 6 L6 26" stroke="#D4A574" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="9" cy="9" r="3.5" stroke="currentColor" strokeWidth="2" />
      <circle cx="9" cy="23" r="3.5" stroke="#D4A574" strokeWidth="2" />
    </svg>
  );
}

export function Wordmark({ className }: { className?: string }) {
  return (
    <span className={`flex items-center gap-2 font-semibold tracking-tighter ${className ?? ''}`}>
      <Logo size={24} />
      <span>Tijera</span>
    </span>
  );
}
